import { getPublicRouteUrl } from '@nackle/service-urls';

export const AUTH_ENDPOINT =  getPublicRouteUrl( 'ID_PROVIDER' );